module.exports = __webpack_public_path__ + "static/0042-4edd453984bd242a10c262cc7cde42dd.png";